import { Button } from "@/components/ui/button";
import { Eye, MinusCircle, PlusCircle } from "lucide-react";
import { UseMutationResult } from "@tanstack/react-query";

interface PlanActionsProps {
  isPersonalPlan?: boolean;
  isSubscribed?: boolean;
  planId: string;
  subscribeMutation: UseMutationResult<any, Error, string>;
  unsubscribeMutation: UseMutationResult<any, Error, string>;
  DialogTrigger: React.ComponentType<any>;
  onViewPlan: () => void;
}

export const PlanActions = ({ 
  isPersonalPlan, 
  isSubscribed,
  planId,
  subscribeMutation,
  unsubscribeMutation,
  DialogTrigger,
  onViewPlan
}: PlanActionsProps) => {
  return (
    <div className="space-y-2 p-3 rounded-lg">
      <DialogTrigger asChild>
        <Button 
          variant="outline" 
          className="w-full bg-secondary text-secondary-foreground hover:bg-secondary/80 border-border"
        >
          <Eye className="mr-2 h-4 w-4" />
          Vista Previa
        </Button>
      </DialogTrigger>

      {!isPersonalPlan && (
        isSubscribed ? (
          <Button
            onClick={() => unsubscribeMutation.mutate(planId)}
            className="w-full bg-destructive text-destructive-foreground hover:bg-destructive/90"
            disabled={unsubscribeMutation.isPending}
          >
            <MinusCircle className="mr-2 h-4 w-4" />
            {unsubscribeMutation.isPending ? "Cancelando..." : "Cancelar Suscripción"}
          </Button>
        ) : (
          <Button
            onClick={() => subscribeMutation.mutate(planId)}
            className="w-full bg-primary text-primary-foreground hover:bg-primary/90"
            disabled={subscribeMutation.isPending}
          >
            <PlusCircle className="mr-2 h-4 w-4" />
            {subscribeMutation.isPending ? "Suscribiendo..." : "Suscribirse al Plan"}
          </Button>
        )
      )}
    </div>
  );
};